import $ from 'jquery';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
export default (function () {
  // Dropdown Menu in Desktop View
  $('.site-navigation-level-2 .dropdown').on({
    'shown.bs.dropdown': function shownBsDropdown(e) {
      var link = e.relatedTarget;
      var menu = link.nextElementSibling;
      var linkRect = link.getBoundingClientRect();
      var menuRect = menu.getBoundingClientRect();
      var docWidth = document.documentElement.offsetWidth;
      var fitsLeft = linkRect.right - menuRect.width >= 0;
      var fitsRight = menuRect.right <= docWidth;
      var ctComponent = $(link).closest('[data-ct-component]');
      var componentName = ctComponent.attr('data-ct-component');
      ctComponent.attr('data-ct-component', componentName.replace('-open', ''));

      var menuPos = function menuPos(w) {
        var mar = (docWidth - w) / 2;
        if (mar >= 0) return mar;
        return 0;
      };

      if (fitsRight) {
        return false;
      }

      if (fitsLeft && !fitsRight) {
        menu.classList.add('dropdown-menu-right');
      } else {
        menu.style.position = 'fixed';
        menu.style.top = "".concat(menuRect.top, "px");
        menu.style.right = "".concat(menuPos(menuRect.width), "px");
        menu.style.left = "".concat(menuPos(menuRect.width), "px");
      }
    },
    'hidden.bs.dropdown': function hiddenBsDropdown(e) {
      var $this = $(e.relatedTarget);
      var $menu = $this.next('.dropdown-menu');
      var ctComponent = $this.closest('[data-ct-component]');
      var componentName = ctComponent.attr('data-ct-component');

      if (!componentName.endsWith('-open')) {
        ctComponent.attr('data-ct-component', "".concat(componentName, "-open"));
      }

      $menu.removeAttr('style');
      $menu.removeClass('dropdown-menu-right');
    }
  });
  $('[data-toggle="slide"]').on('click', function (e) {
    e.preventDefault();
    var $this = $(e.target);
    var targetEle = $this.data('target');
    var $target = $(targetEle);
    $target.toggleClass('open');
    $('html').toggleClass('overflow-hidden');
  });
});